/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const verifyReceiptRequestSchema = z.object({
  platform: z.enum([
    'apple',
    'google',
    'cafebazaar',
    'myket',
    'huawei',
    'samsung',
    'xiaomi',
    'amazon',
    'sideload',
  ]),
  receiptData: z.string(),
  productKey: z.string(),
  transactionId: z.string(),
  originalTransactionId: z.string(),
  purchaseToken: z.string().nullable(),
  purchaseDate: z.number(),
  expiresDate: z.number().nullable(),
  environment: z.enum(['production', 'sandbox']).optional(),
  priceAmountMicros: z.number().optional(),
  priceCurrency: z.string().optional(),
  signature: z.string().optional(),
});

export type IVerifyReceiptRequest = z.infer<typeof verifyReceiptRequestSchema>;
